export default class Phone {
    static valid(phone) {
        return /^(\+?56)?(\s)?(0?[9876543])\s?\d{8}$/.test(phone);
    };
}